/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    AggregatedMeasurementsDTO,
    LastValueConfigDTO,
    ListAggregatedMeasurementsDTO,
    ListMeasurementsDTO,
    MeasurementMultiple,
    MeasurementResponseDto,
    MeasurementResult
} from '@pragma/dto';
import { Observable } from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
    providedIn: 'root'
})
export class MeasurementsService {
    constructor(private readonly _httpClient: HttpClient) {}

    public getList(config: ListMeasurementsDTO): Observable<MeasurementResponseDto[]> {
        // var api: string = '';
        // if (config.tenantType === 'DEFAULT') {
        //     api = 'measurements';
        // } else if (config.tenantType === 'WEATHER') {
        //     api = 'weather-measurements';
        // }
        const url = `/measurements/list?startDate=${config.startDate}&endDate=${config.endDate}&type=${config.type}&field=${config.field}&assignmentToken=${config.assignmentToken}&macAddress=${config.macAddress}&locationId=${config.locationId}`;

        return this._httpClient.get<Array<MeasurementResponseDto>>(url, httpOptions);
    }

    public getListAggregated(config: ListAggregatedMeasurementsDTO): Observable<MeasurementResponseDto[]> {
        var api: string = 'measurements';
        if (config.tenantType === 'WEATHER') {
            api = 'weather-measurements';
        }
        const url = `/measurements/listAggregated?startDate=${config.startDate}&endDate=${config.endDate}&method=${config.method}&groupBy=${config.groupBy}&cumulative=${config.cumulative}&type=${config.type}&field=${config.field}&assignmentToken=${config.assignmentToken}&macAddress=${config.macAddress}&locationId=${config.locationId}`;

        return this._httpClient.get<Array<MeasurementResponseDto>>(url, httpOptions);
    }

    getLastValueMultiple<F = string>(body: {
        locations: {
            locationId: number;
            devices: {
                assignmentToken: string;
                macAddress: string;
                field: string;
                type: string;
                cumulative: string;
                endDate: string;
            }[];
        }[];
    }): Observable<any> {
        return this._httpClient.post<any>('/measurements/bulk/lastValue', body);
    }

    public getAggregatedValue(config: AggregatedMeasurementsDTO): Observable<MeasurementResponseDto[]> {
        var api: string = '';
        if (config.tenantType === 'DEFAULT') {
            api = 'measurements';
        } else if (config.tenantType === 'WEATHER') {
            api = 'weather-measurements';
        }
        const url = `/measurements/aggregated?method=${config.method}&cumulative=${config.cumulative}&type=${config.type}&field=${config.field}&startDate=${config.startDate}&endDate=${config.endDate}&assignmentToken=${config.assignmentToken}&macAddress=${config.macAddress}&locationId=${config.locationId}`;

        return this._httpClient.get<Array<MeasurementResponseDto>>(url, httpOptions);
    }

    public getLastValue(config: LastValueConfigDTO): Observable<MeasurementResponseDto[]> {
        // var api: string = '';
        // if (config.tenantType === 'DEFAULT') {
        //     api = 'measurements';
        // } else if (config.tenantType === 'WEATHER') {
        //     api = 'weather-measurements';
        // }

        const url = `/measurements/lastValue?method=${config.method}&cumulative=${config.cumulative}&type=${config.type}&field=${config.field}&endDate=${config.endDate}&assignmentToken=${config.assignmentToken}&macAddress=${config.macAddress}&locationId=${config.locationId}`;

        return this._httpClient.get<Array<MeasurementResponseDto>>(url, httpOptions);
    }

    getLastValueMobile<F = string>(
        macAddress: string,
        locationId: string,
        type: string,
        field: string,
        cumulative: string,
        assignmentToken: string
    ): Observable<MeasurementResult<F>[]> {
        const params = new HttpParams()
            .set('method', 'lastValue')
            .set('cumulative', cumulative)
            .set('type', type)
            .set('field', field)
            .set('endDate', new Date().toISOString())
            .set('locationId', locationId)
            .set('macAddress', macAddress)
            .set('assignmentToken', assignmentToken);

        return this._httpClient.get<MeasurementResult<F>[]>('/measurements/lastValue', {
            params
        });
    }
}
